import { View, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";

export function NoPermissionScreen({ entityName = "this content" }: { entityName?: string }) {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <MaterialCommunityIcons name="lock" size={64} color={colors.text} style={{ opacity: 0.3 }} />
      <ThemedText type="subtitle" style={styles.title}>
        Access Denied
      </ThemedText>
      <ThemedText style={styles.message}>You don&apos;t have permission to view {entityName}.</ThemedText>
      <ThemedText style={styles.hint}>Contact your administrator if you need access.</ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 32,
    gap: 12,
  },
  title: {
    marginTop: 16,
  },
  message: {
    textAlign: "center",
    opacity: 0.7,
  },
  hint: {
    textAlign: "center",
    fontSize: 12,
    opacity: 0.5,
  },
});
